<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <!-- Bouton retour placé en haut à gauche -->
        <div class="absolute top-4 left-4">
            <router-link to="/">
                <button type="button"
                    class="bg-primary-dark text-white py-2 px-6 rounded transition duration-300 hover:bg-primary">
                    ← Retour
                </button>
            </router-link>
        </div>

        <form @submit.prevent="handleSubmit" class="bg-white p-6 rounded shadow-md w-80">
            <h2 class="text-2xl font-bold mb-4">Créer un compte</h2>

            <div class="mb-4">
                <label for="nom" class="block text-sm font-medium text-gray-700">Nom</label>
                <input v-model="form.nom" id="nom" type="text" required class="mt-1 w-full px-3 py-2 border rounded" />
            </div>

            <div class="mb-4">
                <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                <input v-model="form.email" id="email" type="email" required
                    class="mt-1 w-full px-3 py-2 border rounded" />
            </div>

            <div class="mb-4">
                <label for="password" class="block text-sm font-medium text-gray-700">Mot de passe</label>
                <input v-model="form.password" id="password" type="password" required
                    class="mt-1 w-full px-3 py-2 border rounded" />
            </div>

            <button type="submit" :disabled="loading"
                class="w-full bg-primary text-white py-2 rounded transition duration-300 hover:bg-primary-dark">
                S'inscrire
            </button>

            <router-link to="/login">
                <button type="button"
                    class="w-full my-1 bg-primary text-white py-2 rounded transition duration-300 hover:bg-primary-dark">
                    Déjà un compte ? Se connecter
                </button>
            </router-link>
            <p v-if="errorMessage" class="text-red-500 mt-2">{{ errorMessage }}</p>
        </form>
    </div>
</template>


<script>

// URL de base pour les appels à l'API backend
const baseUrl = process.env.VUE_APP_BASE_URL

export default {
    data() {
        return {
            form: {
                nom: '',
                email: '',
                password: ''
            },
            loading: false,
            errorMessage: ''
        };
    },
    methods: {
        async handleSubmit() {
            if (!this.form.email.trim() || !this.form.password.trim() || !this.form.nom.trim()) {
                this.errorMessage = 'Veuillez remplir tous les champs.';
                return;
            }

            try {
                this.loading = true;
                this.errorMessage = '';

                // 1️⃣ Inscription
                const response = await fetch(`${baseUrl}/api/users/register`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(this.form),
                });

                const data = await response.json();

                if (!response.ok) {
                    this.errorMessage = data.error || data.message || 'Erreur lors de l\'inscription.';
                    return;
                }

                // 2️⃣ Connexion automatique
                const loginResponse = await fetch(`${baseUrl}/api/users/login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email: this.form.email.trim(),
                        password: this.form.password.trim(),
                    }),
                });

                const loginData = await loginResponse.json();

                if (!loginResponse.ok) {
                    this.errorMessage = loginData.error || loginData.message || 'Erreur lors de la connexion.';
                    return;
                }

                // 3️⃣ Sauvegarde du token + user
                if (loginData.token) {
                    localStorage.setItem('token', loginData.token);
                    this.$store.dispatch('login', { user: loginData.user, token: loginData.token });
                    this.$router.push('/dashboard');
                }

            } catch (error) {
                console.error("Erreur lors de l'inscription/connexion:", error);
                this.errorMessage = 'Une erreur est survenue. Veuillez réessayer.';
            } finally {
                this.loading = false;
            }
        }

    }
};
</script>

<style scoped>
/* Tu peux ajouter tes styles personnalisés ici si besoin */
</style>
